import ResidentsScreen from "app/screens/residents/ResidentsScreen";

export default function ResidentsPage() {
  return <ResidentsScreen />;
}
